import ExerciseAnswerState from '../../students/workspace/ExerciseAnswerState';
import StudentAvatar from './StudentAvatar';

// Group counterpart of ExerciseAnswerState.jsx - a single interactive block
// can have up to one answer PER GROUP MEMBER (never merged into one row,
// per the architecture: progress stays 100% personal to each student).
// Members who never answered are skipped entirely ("jesli nie byly zrobione
// to nic" - nothing rendered for them), so this list only ever shows
// members who actually did something. Each row leads with a colored
// initial-letter avatar (hover for the full name) rather than spelling the
// name out inline - compact, and the color alone is usually enough to tell
// several members' rows apart at a glance once you've hovered once.
export default function GroupExerciseAnswerState({ block, members, savedStateByStudentId }) {
   const answered = members.filter(m => savedStateByStudentId[m.studentId]);
   if (answered.length === 0) {
      return <p className='workspace-activity-empty-hint'>Ще ніхто не відповідав.</p>;
   }
   return (
      <div className='group-answer-state-list'>
         {answered.map(m => (
            <div className='group-answer-state-row' key={m.studentId}>
               <StudentAvatar studentId={m.studentId} name={m.name} />
               <div className='group-answer-state-content'>
                  <ExerciseAnswerState block={block} savedState={savedStateByStudentId[m.studentId]} />
               </div>
            </div>
         ))}
      </div>
   );
}
